import { render, staticRenderFns } from "./LeftSvgIconPanel.vue?vue&type=template&id=80195a30&"
import script from "./LeftSvgIconPanel.vue?vue&type=script&lang=js&"
export * from "./LeftSvgIconPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports